import { render } from "./NotFound.vue?vue&type=template&id=777909a6&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=777909a6&scoped=true&lang=css"

import exportComponent from "/home/tyamada/ckan-ext-dev/yamanashi-dataplatform-admin-system-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777909a6"]])

export default __exports__